import {
  GET_CANCELLATION_REASON,
  GET_CANCELLATION_REASON_SUCCESS,
  GET_CANCELLATION_REASON_FAIL,
  ADD_CANCELLATION_REASON,
  ADD_CANCELLATION_REASON_SUCCESS,
  ADD_CANCELLATION_REASON_FAIL,
  UPDATE_CANCELLATION_REASON,
  UPDATE_CANCELLATION_REASON_SUCCESS,
  UPDATE_CANCELLATION_REASON_FAIL,
  DELETE_CANCELLATION_REASON,
  DELETE_CANCELLATION_REASON_SUCCESS,
  DELETE_CANCELLATION_REASON_FAIL,
  SET_CANCELLATION_REASON_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  cancellationReasons: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const cancellationReasonReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CANCELLATION_REASON:
      return { ...state, loading: true }
    case GET_CANCELLATION_REASON_SUCCESS:
      return { ...state, loading: false, cancellationReasons: action.payload }
    case GET_CANCELLATION_REASON_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_CANCELLATION_REASON:
      return { ...state, loading: true }
    case ADD_CANCELLATION_REASON_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} } // Clear field errors on success
    case ADD_CANCELLATION_REASON_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_CANCELLATION_REASON:
      return { ...state, loading: true }
    case UPDATE_CANCELLATION_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        fieldErrors: {}, // Clear field errors on success
      }
    case UPDATE_CANCELLATION_REASON_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_CANCELLATION_REASON:
      return { ...state, loading: true }
    case DELETE_CANCELLATION_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_CANCELLATION_REASON_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_CANCELLATION_REASON_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default cancellationReasonReducer
